<template>
    <div class="main-content" v-if="!loading">
        <h1>
            <span v-translate>Manage My Team</span>: <strong>{{organization.name}}</strong>
        </h1>

        <div class="main-content__my-team-report">
            <div class="my-team-report">
                <h1 class="my-team-report__title" v-translate>Organization strength</h1>
                <div class="my-team-report__section" v-if="organization.teams.length!==0">
                    <h4 class="my-team-report__section-title" v-translate>Total organization strength</h4>
                    <compatibility-sliders :show_categories="showCategories()" :hide_subcategory="hideSubcategoryIfBasic(user_data.navigator_data.package.features.build_your_team)" team_description percentage_sliders :compatibility_categories="compatibility_categories" :reports="average_sum" />
                    <div v-if="user_data.navigator_data.package.features.build_your_team === 'pro'" class="my-team-report__chart">
                        <apexchart type="radar" height="100%" width="100%" :options="chartOptions_average" :series="series_average"></apexchart>
                    </div>
                </div>
                <div class="my-team-report__section" v-if="organization.reports.team_org_leader_sum.length!==0">
                    <h4 class="my-team-report__section-title" v-translate>Total strength of team leaders</h4>
                    <compatibility-sliders :show_categories="showCategories()" :hide_subcategory="hideSubcategoryIfBasic(user_data.navigator_data.package.features.build_your_team)" team_description percentage_sliders :compatibility_categories="compatibility_categories" :reports="organization.reports.team_org_leader_sum" />
                    <div v-if="user_data.navigator_data.package.features.build_your_team === 'pro'" class="my-team-report__chart">
                        <apexchart type="radar" height="100%" width="100%" :options="chartOptions_tol" :series="series_tol"></apexchart>
                    </div>
                </div>
            </div>

            <div class="my-team-report">
                <h1 class="my-team-report__title m-b-xs" v-translate>Impact on leader</h1>
                <div class="my-team-report__explain">
                    <div class="my-people-member-ticker">
                                <div v-if="teamMember(organization.leader).profile_photo"
                                     class="my-people-member-ticker__profile-image">
                                    <img :src="teamMember(organization.leader).profile_photo">
                                </div>
                        <div class="my-people-member-ticker__details">
                            <div class="my-people-member-ticker__name">{{teamMember(organization.leader).first_name}}
                                        {{teamMember(organization.leader).last_name}}</div>
                        </div>
                    </div>
                </div>
                <div class="my-team-report__section" v-if="organization.reports.org_leader_sum.length!==0">
                    <h4 class="my-team-report__section-title" v-translate="{leader_fn: teamMember(organization.leader).first_name, leader_ln: teamMember(organization.leader).last_name}">Organization impact on
                                    %{leader_fn} %{leader_ln}</h4>
                    <compatibility-sliders :show_categories="showCategories()" :hide_subcategory="hideSubcategoryIfBasic(user_data.navigator_data.package.features.build_your_team)" team_description percentage_sliders :compatibility_categories="compatibility_categories" :reports="organization.reports.org_leader_sum" />

                </div>
                <div class="my-team-report__section" v-if="organization.reports.team_leader_sum.length!==0">
                    <h4 class="my-team-report__section-title" v-translate="{leader_fn: teamMember(organization.leader).first_name, leader_ln: teamMember(organization.leader).last_name}">Impact of team leaders on
                                    %{leader_fn} %{leader_ln}</h4>
                    <compatibility-sliders :show_categories="showCategories()" :hide_subcategory="hideSubcategoryIfBasic(user_data.navigator_data.package.features.build_your_team)" team_description percentage_sliders :compatibility_categories="compatibility_categories" :reports="organization.reports.team_leader_sum" />

                </div>
            </div>

            <div class="my-team-report">
                <h1 class="my-team-report__title">Teams</h1>
                <div class="my-team-report__explain" style="margin-bottom:0px;">
                    <button @click="addNewTeam()" class="button button--small button--gray button--green-on-hover" v-translate>
                        Add new team
                    </button>
                </div>

                <div class="list-of-teams">
                    <div v-for="team in organization.teams" :key="team.id" class="list-of-teams__item">
                        <h2 class="list-of-teams__team-name">{{team.name}}</h2>
                        <div class="list-of-teams__section" v-translate>Team leader:</div>
                        <div class="list-of-teams__team-leader">
                            <div class="my-people-member-ticker">
                                <div v-if="teamMember(team.leader).profile_photo"
                                     class="my-people-member-ticker__profile-image">
                                    <img :src="teamMember(team.leader).profile_photo">
                                </div>
                                <div class="my-people-member-ticker__details">
                                    <div class="my-people-member-ticker__name">{{teamMember(team.leader).first_name}}
                                        {{teamMember(team.leader).last_name}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="list-of-teams__section" v-translate>Team members:</div>
                        <div class="list-of-teams__team-members">
                            <div v-for="member in team.members" :key="member" class="my-people-member-ticker">

                                <div v-if="teamMember(member).profile_photo"
                                     class="my-people-member-ticker__profile-image">
                                    <img :src="teamMember(member).profile_photo">
                                </div>

                                <div class="my-people-member-ticker__details">
                                    <div class="my-people-member-ticker__name">{{teamMember(member).first_name}}
                                        {{teamMember(member).last_name}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="list-of-teams__report-section">
                            <div class="my-team-report__section" v-if="team.members.length!==0">
                                <h4 class="my-team-report__section-title" v-translate="{team: team.name}">Total strength of %{team} team</h4>
                                <compatibility-sliders :show_categories="showCategories()" hide_subcategory condensed percentage_sliders :compatibility_categories="compatibility_categories" :reports="team.reports.all_sum" />
                            </div>

                            <div class="my-team-report__section" v-if="team.members.length!==0">
                                <h4 class="my-team-report__section-title" v-translate="{team: team.name, leader_fn: teamMember(team.leader).first_name, leader_ln: teamMember(team.leader).last_name}">Total strength of %{team} team leader
                                    %{leader_fn} %{leader_ln}</h4>
                                <compatibility-sliders :show_categories="showCategories()" hide_subcategory condensed percentage_sliders :compatibility_categories="compatibility_categories" :reports="team.reports.leader_sum" />
                            </div>
                        </div>

                        <div class="list-of-teams__actions">
                            <button class="button button--small button--gray"  v-if="team.members.length!==0 && user_data.navigator_data.package.features.build_your_team === 'pro'"
                                    @click="$router.push({name:'my-team-report-team-details', params: {id:team.id}})" v-translate>View team
                                report
                            </button>
                            <button @click="editTeam(team)" class="button button--small button--gray" v-translate>Edit team</button>
                            <button @click="deleteTeam(team)" class="button button--small button--gray button--red-on-hover" v-translate>Delete
                                team
                            </button>
                        </div>
                    </div>

                    <button class="list-of-teams__item add-new-button" @click="addNewTeam()">
                        <div class="add-new-button__icon icon icon-plus"></div>
                        <div class="add-new-button__text" v-translate>
                            Add new <strong>team</strong>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import VueApexCharts from 'vue-apexcharts';
    import axios from 'axios';
    import {EventBus} from '../event-bus';
    import AddNewTeam from "./popups/AddNewTeam";
    import CompatibilitySliders from "../components/build-my-team/CompatibilitySliders";

    export default {
        name: 'MyTeam-ManageMyTeam',
        components: {
            'apexchart': VueApexCharts,
            'compatibility-sliders': CompatibilitySliders
        },
        data() {
            return {
                average_sum : {},
                add_new_team_popup: AddNewTeam,
                organization: {},
                compatibility_categories: {},
                loading: true,
                people: [],

                expand_subcategory_business: false,
                expand_subcategory_health: false,
                expand_subcategory_relationship: false,
                expand_subcategory_personal: false,

                series_average: [{
                    name: 'Strength',
                    data: [80, 50, 30, 40, 100, 45, 78, 98, 54, 23],
                }],
                series_tol: [{
                    name: 'Strength',
                    data: [80, 50, 30, 40, 100, 45, 78, 98, 54, 23],
                }],
                chartOptions_average: {
                    chart: {
                        type: 'radar',
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        show: false
                    },
                    xaxis: {
                        categories: ['Ideas', 'Creativity', 'Income', 'Passion', 'Career', 'Partnership relation', 'Family relationships', 'Mistress', 'Karma', 'Character']
                    },
                    yaxis: {
                        show: false,
                        max: 100
                    },
                    dataLabels: {
                        enabled: true,
                        background: {
                            enabled: true,
                            borderRadius: 2,
                        },
                        style: {
                            cssClass: 'apexcharts-data-labels',
                        },
                    }
                },
                chartOptions_tol: {
                    chart: {
                        type: 'radar',
                        toolbar: {
                            show: false
                        }
                    },
                    title: {
                        show: false
                    },
                    xaxis: {
                        categories: ['Ideas', 'Creativity', 'Income', 'Passion', 'Career', 'Partnership relation', 'Family relationships', 'Mistress', 'Karma', 'Character']
                    },
                    yaxis: {
                        show: false,
                        max: 100
                    },
                    dataLabels: {
                        enabled: true,
                        background: {
                            enabled: true,
                            borderRadius: 2,
                        },
                        style: {
                            cssClass: 'apexcharts-data-labels',
                        },
                    }
                },
            }
        },
        computed: {
            ...mapState([
                'user_data',
            ]),
        },
        methods: {
            ...mapActions([
                'openPopup',
                'setPopupPayload'
            ]),
            addNewTeam: function () {
                this.setPopupPayload(
                    {
                        organization: this.organization,
                        action: 'create'
                    })
                this.openPopup(this.add_new_team_popup)
            },
            hideSubcategoryIfBasic: function (build_your_team) {
                if (build_your_team === 'pro') {
                    return false;
                }
                return true;
            },
            teamMember: function (member) {
                return this.people.find(person => person.id == member)
            },
            reloadOrganization: async function() {
                this.organization = (await axios.get('/api/navigator/organizations/' + this.$router.currentRoute.params.id + '/')).data
            },
            deleteTeam: async function (team) {
                await axios.delete('/api/navigator/teams/' + team.id + '/')
                this.reloadOrganization()
            },
            editTeam: function (editable_team) {
                this.setPopupPayload(
                    {
                        organization: this.organization,
                        action: 'edit',
                        team: editable_team
                    }
                )
                this.openPopup(this.add_new_team_popup)
            },
            updateChartData: function(){
                let chart_categories = []
                let chart_series = []
                for (let i = 0; i < this.organization.reports.team_org_leader_chart.length; i++) {
                    if(i<10){
                        chart_categories.push(this.organization.reports.team_org_leader_chart[i]['category']);
                        chart_series.push(this.organization.reports.team_org_leader_chart[i]['value']);
                    }
                }
                this.chartOptions_tol.xaxis.categories = chart_categories
                this.series_tol[0].data = chart_series
            },
            updateTeamsAverage: function(){
                this.average_sum = this.loopSum(this.organization.teams, 'all_sum')
            },
            updateTeamsAverageChartData: function(){
                let chart_sum = this.loopChartSum(this.organization.teams, 'apex_chart')
                let chart_categories = []
                let chart_series = []
                for (var i = 0; i < chart_sum.length; i++) {
                   chart_categories.push(chart_sum[i][0]);
                   chart_series.push(chart_sum[i][1]);
                }
                this.chartOptions_average.xaxis.categories = chart_categories
                this.series_average[0].data = chart_series
            },
            loopSum: function(data, subreport){
                let faktor = data.length
                let result = {
                    'business': {},
                    'health': {},
                    'personal': {},
                    'relationship': {}
                }
                data.forEach((team, i) => {
                    for (let [c_key, c_value] of Object.entries(team.reports[subreport])) {
                        for (let[key, value] of Object.entries(c_value)){
                            if(key in result[c_key]) {
                                result[c_key][key] += value
                            } else {
                                result[c_key][key] = value
                            }
                            if(i === faktor - 1){
                                result[c_key][key] = Math.round(result[c_key][key]/faktor)
                            }
                        }
                    }
                });
                return result;
            },
            loopChartSum: function(data, subreport){
                let faktor = data.length
                let result = []
                data.forEach((team, j) => {
                    for (var i = 0; i < team.reports[subreport].length; i++) {
                        if(result[team.reports[subreport][i].category]){
                            result[team.reports[subreport][i].category] += team.reports[subreport][i].value
                        } else {
                            result[team.reports[subreport][i].category] = team.reports[subreport][i].value
                        }
                        if(j === faktor - 1){
                            result[team.reports[subreport][i].category] = Math.round(result[team.reports[subreport][i].category]/faktor)
                        }
                    }
                });
                var sortable = [];
                for (var value in result) {
                    sortable.push([value, result[value]]);
                }
                sortable.sort(function(a, b) {
                    return b[1] - a[1];
                });
                return sortable.slice(0,9)
            },
            showCategories: function() {
                return [
                    this.organization.category_business,
                    this.organization.category_health,
                    this.organization.category_relationship,
                    this.organization.category_personal
                ]
            },
        },
        beforeMount: async function () {
            this.loading = true;
            this.compatibility_categories = (await axios.get('/api/navigator/compatibility-categories/')).data
            this.organization = (await axios.get('/api/navigator/organizations/' + this.$router.currentRoute.params.id + '/')).data
            this.people = (await axios.get('/api/navigator/people/')).data
            this.updateChartData();
            this.updateTeamsAverage();
            this.updateTeamsAverageChartData();
            this.loading = false;
        },
        mounted: function () {
            EventBus.$on('reload-organization', this.reloadOrganization)
        },
        beforeDestroy: function () {
            EventBus.$off('reload-organization')
        }
    }
</script>
